import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const CopyNotification = ({ show }) => {
    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.4 }}
                    style={{
                        position: "fixed", // Fijo en toda la pantalla.
                        top: "20px", // Espaciado desde la parte superior.
                        left: "43.1%", // Centro horizontal exacto.
                        transform: "translate(-50%, 0)", // Asegura el centrado horizontal.
                        background: "rgba(255, 255, 255, 0.1)",
                        color: "#f1faee",
                        padding: "12px 24px",
                        borderRadius: "12px",
                        fontSize: "14px",
                        fontWeight: "500",
                        boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.2)",
                        backdropFilter: "blur(8px)",
                        border: "1px solid rgba(255, 255, 255, 0.2)",
                        zIndex: 9999, // Alta prioridad.
                        maxWidth: "90%", // Evita que el componente sobresalga de la pantalla.
                        textAlign: "center", // Centra el texto dentro del componente.
                    }}
                >
                    ¡Copiado al portapapeles!
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default CopyNotification;
